// extracted by mini-css-extract-plugin
export var infoItem = "_qd-2";
export var title = "_qd-0";
export var value = "_qd-1";